import { createStorageAtomFactory } from '@exodus/atoms';
const createBackedUpAtom = ({ storage }) => {
    const createStorageAtom = createStorageAtomFactory({ storage });
    return createStorageAtom({
        key: 'backedUp',
    });
};
export const backedUpAtomDefinition = {
    id: 'backedUpAtom',
    type: 'atom',
    factory: createBackedUpAtom,
    dependencies: ['storage'],
};
